import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { trackListingView } from './ListingPage.duck';

/**
 * Logs one listing view (view_item / ViewContent) per listing shown on the
 * page. Lives in the page rather than in showListing: hydration skips loadData
 * for the server-rendered landing page, and CheckoutPage reuses showListing.
 *
 * @param {object} listing current listing entity
 */
const useTrackListingView = (listing) => {
  const dispatch = useDispatch();
  const trackedIdRef = useRef(null);
  const listingId = listing.id?.uuid;
  // Copies cached by other pages (nearby, inbox, calendar) can lack the fields
  // the event needs; wait for one that has them (search results or showListing).
  const hasEventFields = !!(listing.attributes?.state && listing.attributes?.price);

  useEffect(() => {
    if (!listingId || !hasEventFields || trackedIdRef.current === listingId) return;
    trackedIdRef.current = listingId;
    dispatch(trackListingView(listing));
    // listing is intentionally excluded: track once per id, not per entity update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, listingId, hasEventFields]);
};

export default useTrackListingView;
